import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    createPolicies: [],
    loading: false,
    error: null,
}

const createPoliciesSlice = createSlice({
    name: "createPolicies",
    initialState,
    reducers: {
        fetchCreatePoliciesSucess: (state, action) => {
            state.loading = false
            state.createPolicies = action.payload;
        },
        fetchCreatePoliciesFailure: (state, action) => {
            state.loading = false
            state.error = action.payload;
        },
    },
})

export const {
    fetchCreatePoliciesSucess,
    fetchCreatePoliciesFailure,
} = createPoliciesSlice.actions;

export default createPoliciesSlice.reducer;